import { Link, useLocation } from "react-router-dom";
import { cn } from "../../lib/utils";
import { User, Link as LinkIcon, Settings, CreditCard } from "lucide-react";
import React from "react";

const navItems = [
  {
    title: "Profile",
    href: "/app/settings/profile",
    icon: User,
  },
  {
    title: "Preferences",
    href: "/app/settings/preferences",
    icon: Settings,
  },
  {
    title: "Billing",
    href: "/app/settings/billing",
    icon: CreditCard,
  },
  {
    title: "Integrations",
    href: "/app/settings/integrations",
    icon: LinkIcon,
  },
];

export function SettingsNav() {
  const location = useLocation();

  return (
    <nav className="flex space-x-2 border-b">
      {navItems.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          className={cn(
            "flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors hover:text-primary",
            location.pathname.startsWith(item.href)
              ? "border-b-2 border-primary text-primary"
              : "text-muted-foreground"
          )}
        >
          <item.icon className="h-4 w-4" />
          {item.title}
        </Link>
      ))}
    </nav>
  );
}